import { Ship } from './Ship';
export class Identity {
  userCreated: Date;
  userModified: Date;
  dateCreated: Date;
  dateModified: Date;
  copierChanged: boolean;
  copierValidated: boolean;
  idSeq: number;
  lastName: string;
  middleName: string;
  firstName: string;
  socialSecurity: number;
  status: string;
  militaryBranch: string;
  payGrade: string;
  meu: string;
  currentShip: Ship;
  dob: string;
  dateOfBirth: String;
  mothersMaidenName: string;
  formStorage: string;
  formSeq: number;
  dda: number;
}
